import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { IProviderDto, IProviderRdvDto } from "../dto/dashboard";

@Injectable({ providedIn: 'root' })
export class ProviderService {
    private http = inject(HttpClient);
    private BASE_URL = environment.api.url;

    initializeProviderDetails(providerId: string): Observable<IProviderDto> {
        return this.http.get<IProviderDto>(`${this.BASE_URL}/dashboard/provider/${providerId}`);
    }

    getProviders(): Observable<IProviderDto[]> {
        return this.http.get<IProviderDto[]>(`${this.BASE_URL}/dashboard/providers`);
    }

    createStripeConnectAccount(providerId: string): Observable<void> {
        return this.http.post<void>(`${this.BASE_URL}/dashboard/provider/${providerId}/stripe-connect`,
            {}
        );
    }

    validateAppointment(providerId: string): Observable<IProviderRdvDto> {
        return this.http.post<IProviderRdvDto>(`${this.BASE_URL}/dashboard/provider/${providerId}/validate-appointment`,
            {}
        );
    }
}